module.exports = {
  siteName: 'Practicesuite',
  logoIconPath: '/logo.svg',
  logoPath: '/logo.png',
  apiPrefix: '/api/v1',
  fixedHeader: true, // sticky primary layout header

  /* Layout configuration, specify which layout to use for route. */
  layouts: [
    {
      name: 'doctor',
      include: [ /(\/(en|zh))*\/facility\/(.*)/],
      exclude: [/(\/(en|zh))*\/facility\/patient-profile\/(.*)/,
        /(\/(en|zh))*\/facility\/doctor-register\/(.*)/,
        /(\/(en|zh))*\/facility\/chat-doctor/],
    },
    {
      name: 'patient',      
      include: [ /(\/(en|zh))*\/patient\/(.*)/, 
         /(\/(en|zh))*\/doctor-profile\/(.*)/, 
        /(\/(en|zh))*\/search/,
        /(\/(en|zh))*\/booking/,
         /(\/(en|zh))*\/profile\/(.*)/, ],
      exclude: [/(\/(en|zh))*\/login/,
        /(\/(en|zh))*\/patient\/patientmessages/, /(\/(en|zh))*\/patient\/chat-doctor/, 
        // /(\/(en|zh))*\/patient\/qr-scanner/,
        /(\/(en|zh))*\/blog\/blog-list/,
        /(\/(en|zh))*\/blog\/blog-details/,],
    },
    {
      name: 'breadCrumb',
      include: [ /(\/(en|zh))*\/doctor\/patient-profile\/(.*)/,
          /(\/(en|zh))*\/doctor\/doctor-register\/(.*)/],
      exclude: [/(\/(en|zh))*\/login/],
    },
    {
      name: 'noContainer',
      include: [/(\/(en|zh))*\/patient\/qr-scanner/,
        /(\/(en|zh))*\/messages\/(.*)/,
        /(\/(en|zh))*\/sso\/message/,],
    },
    {
      name: 'patientSidebr',
      include: [/(\/(en|zh))*\/patient\/patientmessages/],
    },
  ],

  /* I18n configuration, `languages` and `defaultLanguage` are required currently. */
  i18n: {
    /* Countrys flags: https://www.flaticon.com/packs/countrys-flags */
    languages: [
      {
        key: 'pt-br',
        title: 'Português',
        flag: '/portugal.svg',
      },
      {
        key: 'en',
        title: 'English',
        flag: '/america.svg',
      },
      {
        key: 'zh',
        title: '中文',
        flag: '/china.svg',
      },
    ],
    defaultLanguage: 'en',
  },
}
